export function downloadFromPresignedUrl(presignedUrl: string) {
  const link = document.createElement('a');
  link.href = presignedUrl;
  link.setAttribute('download', '');
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
